export default {
    OK: 'OK',
    ERRO: 'ERRO'
}
